const menu = document.querySelector(".header__inline-menu");

if (menu) {
  const items = menu.querySelectorAll("details");

  items.forEach((item) => {
    let closeTimer;
    const summary = item.querySelector("summary");

    // OPEN on hover
    item.addEventListener("mouseenter", () => {
      if (window.innerWidth >= 990) {
        clearTimeout(closeTimer);
        item.setAttribute("open", true);
      }
    });

    // CLOSE on mouse leave (with delay)
    item.addEventListener("mouseleave", () => {
      if (window.innerWidth >= 990) {
        closeTimer = setTimeout(() => {
          item.removeAttribute("open");
        }, 150);
      }
    });

    // 🔥 HARD-CODED CLICK REDIRECT (DESKTOP ONLY)
    if (summary) {
      const id = summary.getAttribute("id");
      console.log(id);
      if (id === "HeaderMenu-pokemon") {
        summary.addEventListener("click", (e) => {
        if (window.innerWidth >= 990) {
          console.log(id);
          e.preventDefault(); // stop dropdown toggle
          window.location.href =
            "https://duckduckgnc.com/pages/pokemon-landing";
        }
      })
    };
      if (id === "HeaderMenu-riftbound") {
        summary.addEventListener("click", (e) => {
        if (window.innerWidth >= 990) {
          console.log(id);
          e.preventDefault(); // stop dropdown toggle
          window.location.href =
            "https://duckduckgnc.com/pages/riftbound-products";
        }
      });
      }
    }
  });
}
